import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const BrowserSuggestionStyles = makeStyles()((theme: Theme) => ({
  title: {
    marginBottom: '1.25rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
    },
  },
  content: {
    fontWeight: 600,
    marginBottom: '1.75rem',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex',
      flexDirection: 'column',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  browser: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.25rem',
      '&:last-of-type': {
        marginBottom: 0,
      },
    },
  },
  browserIcon: {
    fontSize: '2rem',
    marginLeft: '25px',
    marginRight: '10px',

    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  firstBrowserIcon: {
    marginLeft: '0px',
  },
}));
